module.exports = __webpack_public_path__ + "static/media/hawaiian_classic.51cbea06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dish_image/hawaiian_classic.jpg
// module id = 159
// module chunks = 0